import { Box, Card, CardContent, CardHeader, Divider, Stack } from '@mui/material';

import { CalendarClockIcon, Typography } from '@occc-app/design-system';
import { FormattedScheduleListItem } from '@occc-app/lib/util-location-schedule';

type StoreConfigurationCardProps = {
  schedule: FormattedScheduleListItem[];
  attributes: string[];
};

const WorkingHours = ({ schedule }: { schedule: FormattedScheduleListItem[] }) => (
  <Stack direction='row' spacing={1.5}>
    <CalendarClockIcon color='disabled' />
    <Box>
      <Typography variant='subtitle2' gutterBottom>
        Working Hours
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 2, rowGap: 0.5 }}>
        {schedule.length ? (
          schedule.map(({ period, timeSchedule }) => (
            <Box key={period} sx={{ display: 'contents' }}>
              <Typography variant='body2'>{period}:</Typography>
              <Typography variant='body2'>{timeSchedule}</Typography>
            </Box>
          ))
        ) : (
          <Typography variant='body2' color='textSecondary' sx={{ gridColumn: '1 / -1' }}>
            No working hours set
          </Typography>
        )}
      </Box>
    </Box>
  </Stack>
);

const AvailableServices = ({ attributes }: { attributes: string[] }) => {
  const columnCount = 3;
  const rowCount = Math.ceil(attributes.length / columnCount);

  return (
    <Box>
      <Typography variant='subtitle2' gutterBottom>
        Available Services
      </Typography>
      {attributes.length ? (
        <Box
          sx={{
            display: 'grid',
            gap: 1,
            gridAutoFlow: 'column',
            gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: `repeat(${columnCount}, 1fr)` },
            gridTemplateRows: {
              xs: `repeat(${attributes.length}, auto)`,
              sm: `repeat(${rowCount}, auto)`,
            },
          }}
        >
          {attributes.map((attribute, index) => (
            <Typography key={`${attribute}-${index}`} variant='body2'>
              {attribute}
            </Typography>
          ))}
        </Box>
      ) : (
        <Typography variant='body2' color='textSecondary'>
          No services
        </Typography>
      )}
    </Box>
  );
};

export const StoreConfigurationCard = ({ schedule, attributes }: StoreConfigurationCardProps) => (
  <Card sx={{ height: '100%' }}>
    <CardHeader
      title={
        <Typography variant='h6' component='h3'>
          Store Configuration
        </Typography>
      }
    />
    <CardContent sx={{ pt: 0 }}>
      <WorkingHours schedule={schedule} />
      <Divider sx={{ my: 2 }} />
      <AvailableServices attributes={attributes} />
    </CardContent>
  </Card>
);
